import React, { FormEvent, useState} from 'react'
import styled from 'styled-components';
import LogoImg from '../assets/logo.png'; 
import Icon5 from '../assets/carreau.svg'
import { NavLink as RouterNavLink } from 'react-router-dom'
import BurgerImg from '../assets/Burger.svg'

const NavbarContainer = styled.nav`
  width: 100%;
  padding: 0 2rem;
  height: 60px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  position: relative;
  background: #000;
  @media (max-width: 900px) {
    grid-template-columns: auto 1fr auto;
  }
`

const LogoWrapper = styled(RouterNavLink)`
  justify-self: start;
  display: flex;
  align-items: center;
`

const Logo = styled.img`
  height: 40px;
  cursor: pointer;
`

const NavLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  grid-column: 2;
  @media (max-width: 900px) {
    display: none;
  }
`

const StyledNavLink = styled(RouterNavLink)`
  text-decoration: none;
  font-family: 'PoppinsMedium';
  color: #fff;
  font-weight: 500;
  transition: color 0.2s;
`

const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-self: end;
  grid-column: 3;
  @media (max-width: 900px) {
    display: none;
  }
`

const LanguageButton = styled.button`
  background: none;
  border: none;
  font-size: 0.9rem;
  color: #fff;
  cursor: pointer;
  font-family: 'PoppinsMedium';
`

const DiscoverButton = styled.button`
  background: #fff;
  border: 1px solid #333;
  border-radius: 20px;
  padding: 0.5rem 1rem;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration:none;
  font-family: 'MongoGrotesqueLight';
  transition: background-color 0.2s, color 0.2s;
`

const BurgerButton = styled.button`
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 10;
  @media (max-width: 900px) {
    display: block;
    justify-self: end;
  }
`

const BurgerIcon = styled.img`
  width: 30px;
  height: auto;
`

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100vh;
  background: rgba(0,0,0,0.5);
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  z-index:5;
  overflow:hidden;
  
`

const MobileMenu = styled.div`
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  background: rgba(0,0,0,0.5);
  z-index: 6;

  a, button {
    color: #fff;
    font-size: 1.2rem;
  }
  ${DiscoverButton} {
    background: #fff;
    color: #000;
  }
`


const DiscoverButton2 = styled.button`
  background: #fff;
  border: 1px solid #333;
  width:30%;
  border-radius: 20px;
  padding: 0.5rem 1rem;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  font-family: 'MongoGrotesqueLight';
  text-decoration:none;
  transition: background-color 0.2s, color 0.2s;
  @media (min-width: 1500px) {
    width: 10%;
  }
  @media (max-width: 760px) {
       width: 50%;
  }
  &:hover {
    background: black;
    color: white;
    border-color: white;
    transition: background 0.5s ease;
  }
`;

const Title = styled.p`
  font-size: 8rem;
  color: #fff;
  font-family: 'MongoGrotesqueLight';
    margin:0;
    @media (max-width: 900px) {
      font-size: 6rem;
    }
`;


const LeftSection = styled.div`
  flex: 1;
  padding-right: 2rem;

  @media (max-width: 1024px) {
    padding-right: 0rem;
  }
`

const RightSection = styled.div`
  flex: 1;
  padding-left: 2rem;
  @media (min-width: 1500px) {
    padding-left: 0rem;
    
  }
  @media (max-width: 1024px) {
    padding-left: 0rem;
    width:85%;
  }
  @media (max-width: 760px) {
    width:100%;
    text-align:left;
    padding-left: 0rem;
     }
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  @media (max-width: 760px) {
   width:100%;
  
    }
  @media (max-width: 410px) {
  
  }
`

const Row = styled.div`
  display: flex;
  gap: 2rem;
  margin-bottom: 1.5rem;
  @media (max-width: 760px) {
  flex-direction:column;
  width:100%;

  }
`

const Field = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

const EmptyField = styled.div`
  flex: 1;
`

const Label = styled.label`
  font-size: 1rem;
  margin-bottom: 0.5rem;
  color: white;
`

const Input = styled.input`
  border: none;
  border-bottom: 1px solid #ccc;
  padding: 0.5rem 0;
  font-size: 1rem;
  outline: none;
  background-color:black;
  color: white;
`

const Textarea = styled.textarea`
  border: none;
  border-bottom: 1px solid #ccc;
  padding: 0.5rem 0;
  font-size: 1rem;
  outline: none;
  background-color:black;
  resize: vertical;
  color: white;
`

const SubmitButton = styled.button`
  margin-top: 2rem;
  align-self: flex-start;
  padding: 0.75rem 2rem;
  background-color: #333;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 1rem;
`

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #ddd;
  font-family: 'PoppinsMedium';
  @media (max-width: 1024px) {
    padding-bottom: 2rem;
  }
  
`;

const PageContainer = styled.div`
  background-color: #000;
  color: #fff;
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom:5rem; 
   @media (max-width: 1024px) {
    min-height: auto;
  }

`;

const Section = styled.div`
  display: flex;
  flex-direction: row;
  width:100%;
  padding : 4rem;
  padding-top:6rem;
  @media (min-width: 1500px) {
    flex-direction: column;
    
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items:center;
    justify-content:center;
    padding : 3rem;
  }
`;

const LargeIcon = styled.img`
  width: 200px;
  height: 200px;
  position: absolute;
  left: -7%;
  top: 45%;
  @media (min-width: 1500px) {
    left: 94%;
    width: 250px;
    top: 20%;
  height: 250px;
    
  }
  @media (max-width: 1024px) {
    display:none;
  }
`

const SuccessMessage = styled.p`
  color: #4CAF50;
  margin-top: 1rem;
  font-size: 0.9rem;
  font-family: 'PoppinsMedium';
`;


const ContactezNous = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messageSuccess, setMessageSuccess] = useState(false)

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const nom = formData.get('nom')?.toString().trim() || '';
    const prenom = formData.get('prenom')?.toString().trim() || '';
    const sujet = formData.get('sujet')?.toString().trim() || '';

    if (!nom) {
      alert('Veuillez remplir le champ Nom.');
      return;
    }
    if (!prenom) {
      alert('Veuillez remplir le champ Prénom.');
      return;
    }
    if (!sujet) {
      alert('Veuillez remplir le champ Sujet.');
      return;
    }

    try {
      setMessageSuccess(true);
      e.currentTarget.reset();
      setTimeout(() => setMessageSuccess(false), 3000);


    } catch (error) {
      console.error(error);
      alert('Une erreur est survenue. Veuillez réessayer.');
    }
  };
  return (
    <PageContainer>
        <NavbarContainer>
      <LogoWrapper to="/"><Logo src={LogoImg} alt="Logo" /></LogoWrapper>
      <NavLinks>
        <StyledNavLink to="/aboutus">À PROPOS DE NOUS</StyledNavLink>
        <StyledNavLink to="/jockerclub">JOKER CLUB</StyledNavLink>
        <StyledNavLink to="/">MULTISHOP</StyledNavLink>
        <StyledNavLink to="/contactus">CONTACT</StyledNavLink>
      </NavLinks>
      <RightActions>
   
           {/*<LanguageButton>ENG</LanguageButton>*/}
        <DiscoverButton>JE DÉCOUVRE</DiscoverButton>
      </RightActions>
      <BurgerButton onClick={() => setIsOpen(!isOpen)}>
        <BurgerIcon src={BurgerImg} alt="Menu" />
      </BurgerButton>
    </NavbarContainer>

    {isOpen && (
      <>
        <Overlay onClick={() => setIsOpen(false)} />
        <MobileMenu>
          <StyledNavLink to="/aboutus" onClick={() => setIsOpen(false)}>
            À PROPOS DE NOUS
          </StyledNavLink>
          <StyledNavLink to="/jockerclub" onClick={() => setIsOpen(false)}>
            JOKER CLUB
          </StyledNavLink>
          <StyledNavLink to="/" onClick={() => setIsOpen(false)}>
            MULTISHOP
          </StyledNavLink>
          <StyledNavLink to="/contactus" onClick={() => setIsOpen(false)}>
            CONTACTEZ-NOUS
          </StyledNavLink>
             {/*<LanguageButton onClick={() => setIsOpen(false)}>ENG</LanguageButton>*/}
          <DiscoverButton onClick={() => setIsOpen(false)}>JE DÉCOUVRE</DiscoverButton>
        </MobileMenu>
      </>
    )}
        <Section>
        <LeftSection>
            <Title>CONTACTEZ-NOUS</Title>
            <Subtitle>
                Vous avez une question, un commentaire ou besoin d’assistance ?<br/>
            </Subtitle>
        </LeftSection>
        <RightSection>
        <Form onSubmit={handleSubmit}>
            <Row>
              <Field>
                  <Label htmlFor="nom">Nom *</Label>
                  <Input id="nom" name="nom" type="text" required />
              </Field>

              <Field>
                  <Label htmlFor="prenom">Prénom *</Label>
                  <Input id="prenom" name="prenom" type="text" required />
              </Field>
            </Row>
            <Row>
              <Field>
                  <Label htmlFor="sujet">Sujet *</Label>
                  <Input id="sujet" name="sujet" type="text" required />
              </Field>

              <Field>
                  <Label htmlFor="telephone">Téléphone</Label>
                  <Input id="telephone" name="telephone" type="tel" />
              </Field>
            </Row>
            <Row>
              <Field>
                  <Label htmlFor="message">Message</Label>
                  <Textarea id="message" name="message" rows={2} />
              </Field>
              <EmptyField />
            </Row>
          <DiscoverButton2 type="submit">ENVOYEZ LE MESSAGE</DiscoverButton2>
          {messageSuccess && (
            <SuccessMessage>
              Votre message a été envoyé avec succès.
            </SuccessMessage>
          )}
        </Form>
        </RightSection>
        </Section>
        <LargeIcon src={Icon5} alt="Icon 1" />
    </PageContainer>
  )
}

export default ContactezNous